import { render } from "./RolePermissionTab.vue?vue&type=template&id=2414a408&scoped=true"
import script from "./RolePermissionTab.vue?vue&type=script&lang=js"
export * from "./RolePermissionTab.vue?vue&type=script&lang=js"

import "./RolePermissionTab.vue?vue&type=style&index=0&id=2414a408&lang=scss&scoped=true"
import "./RolePermissionTab.vue?vue&type=style&index=1&id=2414a408&lang=scss"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2414a408"]])

export default __exports__